const types = {
  DOB_UPDATE_FAILED: 'DOB_UPDATE_FAILED',
  DOB_UPDATE_REQUESTED: 'DOB_UPDATE_REQUESTED',
  DOB_UPDATE_SUCCESS: 'DOB_UPDATE_SUCCESS',
  MODAL_CHANGE_DATE: 'MODAL_CHANGE_DATE',
  MODAL_CLOSE: 'MODAL_CLOSE'
};

export default types;
